import styles from "./ProductCard.module.css";

const PlaceholderImg = ({ name }) => (
  <div className={styles.placeholderBox}>
    <div className={styles.placeholderIcon}>◈</div>
    <div className={styles.placeholderName}>{name?.charAt(0)?.toUpperCase()}</div>
  </div>
);

export default function ProductCard({ product, onOrder }) {
  const imgUrl = product.images?.[0]?.url || null;

  return (
    <div className={styles.card}>
      <div className={styles.img}>
        {imgUrl
          ? <img src={imgUrl} alt={product.name}
              onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
          : null}
        <div style={{ display: imgUrl ? "none" : "flex" }} className={styles.placeholderBox}>
          <div className={styles.placeholderIcon}>◈</div>
        </div>
        {product.stock === 0 && <div className={styles.outOfStock}>Out of stock</div>}
      </div>
      <div className={styles.body}>
        <div className={styles.category}>{product.category}</div>
        <div className={styles.name}>{product.name}</div>
        <div className={styles.price}>₹{product.price?.toLocaleString()}</div>
        <div className={styles.meta}>
          {product.stock > 0
            ? <span className="badge badge-green">In stock ({product.stock})</span>
            : <span className="badge badge-red">Out of stock</span>}
        </div>
        {product.stock > 0 && (
          <button className={`btn btn-primary ${styles.orderBtn}`} onClick={onOrder}>
            Add to cart
          </button>
        )}
      </div>
    </div>
  );
}
